<template>
    <div>
        <el-container class="content">
            <template v-for="(type,index) in qualificationGroup">
                <template v-if="type.qualificationList.length > 0">
                    <el-card>
                    <div slot="header" class="clearfix" :key="index">
                        <div class="type-title">
                            <template v-if="type._id === 1">
                                <span class="mustIcon">*</span>
                            </template>
                            <span>{{ type.type }}</span>
                        </div>
                    </div>
                    <div class="uploadQualification">
                        <el-row :gutter="20" style="display: flex;flex-direction: column;gap: 20px;">
                            <template v-for="(item,index) in type.qualificationList">
                                <el-col :span="24">
                                    <div style="display: flex;align-items: flex-start;gap: 40px">
                                        <div class="qualificationUploadItem">
                                            <div class="uploadTitle">
                                                <template v-if="item.is_must">
                                                    <span class="mustIcon">*</span>
                                                </template>
                                                <span class="name">{{ item.name }}</span>
                                            </div>
                                            <el-upload
                                                class="avatar-uploader"
                                                :action="$config.baseUrl + 'api/i/image'"
                                                :on-success="(res, file)=>{
                                                return handleAvatarSuccess(res,file,item,index)
                                            }"
                                                :on-remove="(file, fileList) => {
                                            return handleRemove(file, fileList,item)
                                            }"
                                               :before-upload="(file) => beforeAvatarUpload(file, item.name)">
                                                <div v-if="item.image" class="avatar">
                                                    <img class="qualificationImg" :src="item.image">
                                                </div>
                                                <i v-else
                                                   :style="{backgroundImage: uploadItemBg, backgroundSize: 'cover'}"
                                                   class="el-icon-plus avatar-uploader-icon "></i>
                                            </el-upload>
                                            <div class="manageBox">
                                                <template v-if="item.template_url">
                                                    <div class="downLoadTemplate"
                                                        @click.stop="downLoadTemplate(item.template_url)">
                                                        下载模板
                                                    </div>
                                                </template>
                                                <template v-if="item.example_photos">
                                                    <div class="examplePhotos" @click="showExampleDialog(item.example_photos)">
                                                        示例详情
                                                    </div>
                                                </template>
                                            </div>
                                            
                                        </div>
                                        <div class="qualificationInfoBox">
                                            <template v-if="item.status !== -2 && auditStatus(item.status).passFail">
                                                <div class="customItemClass">
                                                    <span>审核状态：</span>
                                                    <span
                                                        :style="{color:auditStatus(item.status).color}">{{ auditStatus(item.status).words
                                                        }}</span>
                                                </div>
                                            </template>
                                            <template v-if="item.expire_prompt === 3">
                                                <div style="color: red">
                                                    <span style="color: red;margin-right: 5px">*</span>
                                                    <span>已过期，急需上传新证件并更新资质信息</span>
                                                </div>
                                            </template>
                                            <template>
                                                <div class="customItemClass">
                                                    <span>有效期&emsp;&emsp;&nbsp;&nbsp;</span>
                                                    <el-radio-group v-model="item.long_term" :disabled="!item.image">
                                                        <el-radio :label="0">效期</el-radio>
                                                        <el-radio :disabled="item.is_need_long_time === 0" :label="1">长期
                                                        </el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </template>
                                            <div v-show="item.long_term === 0 || item.long_term === 1">
                                                <div class="customItemClass" style="margin-bottom: 12px;">
                                                    <span class="label-title" style="position: relative;"><span style="color: red;font-size: 30px;position: absolute;left: -18px;">*</span>开始日期</span>
                                                    <el-date-picker
                                                        :disabled="!item.image"
                                                        size="small"
                                                        value-format="yyyy-MM-dd"
                                                        v-model="item.expiration_start_date"
                                                        type="date"
                                                        @change="checkDates(item.expiration_start_date,item.expiration_end_date,index)"
                                                        placeholder="选择开始日期">
                                                    </el-date-picker>
                                                </div>
                                                <template v-if="item.long_term !== 1">
                                                    <div class="customItemClass">
                                                        <span class="label-title" style="position: relative;"><span style="color: red;font-size: 30px;position: absolute;left: -18px;">*</span>结束日期</span>
                                                        <el-date-picker
                                                            :disabled="!item.image"
                                                            value-format="yyyy-MM-dd"
                                                            size="small"
                                                            v-model="item.expiration_end_date"
                                                            type="date"
                                                            @change="checkDates(item.expiration_start_date,item.expiration_end_date,index)"
                                                            placeholder="选择结束日期">
                                                        </el-date-picker>
                                                    </div>
                                                </template>
                                            </div>
                                            <template v-if="item.is_need_card_no == 1">
                                                <div class="customItemClass">
                                                    <span class="label-title">证件编号</span>
                                                    <el-input :disabled="!item.image" size="small" placeholder="请输入内容"
                                                              v-model="item.card_no">
                                                    </el-input>
                                                </div>
                                            </template>
                                            <template v-if="item.custom">
                                                <div class="customItemClass" v-for="(customItem,customIndex) in item.custom" :key="customIndex">
                                                    <span style="position: relative;"><span v-if="customItem.required==1" style="color: red;font-size: 30px;position: absolute;left: -18px;">*</span>{{ customItem.name }}</span>
                                                    <el-input :disabled="!item.image" size="small" placeholder="请输入内容" style="width: 220px;" v-model="customItem.value" @change="inputChange(customItem)"></el-input>
                                                </div>
                                            </template>
                                            <template v-if="item.business_scope_list&&item.business_scope_list.length>0">
                                                <div class="customItemClass">
                                                    <span style="position: relative;"><span style="color: red;font-size: 30px;position: absolute;left: -18px;">*</span>经营范围</span>
                                                    <el-select :disabled="!item.image" style="width: 220px;" size="small" v-model="item.business_scope_value" multiple collapse-tags placeholder="请选择经营范围">
                                                        <el-option v-for="item1 in item.business_scope_list" :key="item1.id" :label="item1.name" :value="item1.id"></el-option>
                                                    </el-select>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <template v-if="item.content || !item.image">
                                        <div class="uploadTip">
                                            <span>{{ item.content }}</span>
                                            <span v-if="!item.image">请先上传证件图片才可编辑信息</span>
                                        </div>
                                    </template>
                                </el-col>
                            </template>
                        </el-row>
                    
                    </div>
                </el-card>
                </template>
                
            </template>
            <div style="margin-top: 10px;display: grid">
                <el-button type="primary" @click="onsubmit">提交</el-button>
            </div>
        </el-container>
        <el-dialog title="示例详情" :visible.sync="exampleDialogVisible" width="50%">
            <div class="examplePhotos" @click="handleExampleDialogClick">
                <div v-html="examplePhotosInfo"></div>
            </div>
        </el-dialog>
        <el-image v-show="false" ref="previewImage" :src="previewImage" :preview-src-list="[previewImage]"></el-image>
    </div>
</template>

<script>
    import { qualificationConfig, qualificationUpload, memberQualification } from "@/api/member/info"
    
    export default {
        data() {
            return {
                uploadItemBg: `url(${this.$config.baseUrl}/upload/uniapp/new/icon/qualificationBg.png)`,
                qualificationList: [],
                imageUrl: "",
                exampleDialogVisible:false,
                examplePhotosInfo:'',
                previewImage:''
            }
        },
        async created() {
            await this.getQualificationConfig()
            await this.getMemberQualification()
        },
        methods: {
            showExampleDialog(info){
                this.examplePhotosInfo = info
                this.exampleDialogVisible = true
            },
            handleExampleDialogClick(e){
                const img = e.target.src
                this.previewImage = img
                this.$refs.previewImage.showViewer = true;
            },
            checkDates(startDate, endDate, index) {
                if (startDate && endDate) {
                    let start = new Date(startDate)
                    let end = new Date(endDate)
                    if (start > end) {
                        this.$message.error("开始日期不能大于结束日期")
                        // 重置开始日期为结束日期
                        this.qualificationList[index]["expiration_end_date"] = "";
                    }
                }
            },
            downLoadTemplate(url) {
                window.location.href = url
            },
            auditStatus(status) {
                let audit = { passFail: true, words: "", color: "#2FBC6D" }
                switch (status) {
                    case 0:
                        audit.passFail = true
                        audit.words = "待审核"
                        audit.color = "#FF5A5A"
                        break
                    case 1:
                        audit.passFail = false
                        audit.words = "审核通过"
                        break
                    case -1:
                        audit.passFail = true
                        audit.words = "审核拒绝，待重新提交"
                        audit.color = "#FF5A5A"
                        break
                }
                return audit
            },
            async getMemberQualification() {
                const res = await memberQualification()
                // 更新全部资质数组的内容
                if (res.code === 0 && res.data.length) {
                    const memberQualificationList = res.data
                    // 需要更新的字段
                    let needUpdate = ["image", "card_no", "expiration_end_date", "expiration_start_date", "expire_prompt", "status", "long_term","custom","business_scope"]
                    this.qualificationList.forEach(ele => {
                        const index = memberQualificationList.findIndex(item => item.identify === ele.identify)
                        if (index !== -1) {
                            for (let i = 0; i < needUpdate.length; i++) {
                                if(needUpdate[i]==='business_scope'&&memberQualificationList[index][needUpdate[i]]!=undefined&&memberQualificationList[index][needUpdate[i]]!=null){
                                    if(memberQualificationList[index][needUpdate[i]]!=''){
                                        let temArr = memberQualificationList[index][needUpdate[i]].split(",").map(item=> Number(item.trim()));
                                        ele.business_scope_value = temArr;
                                    }else{
                                        ele.business_scope_value = [];
                                    }
                                }else if(needUpdate[i] === 'custom' && ele.custom){
                                    ele.custom.forEach(_c => {
										if (memberQualificationList[index].custom) {
											memberQualificationList[index].custom.forEach(_t => {
												if (_c.key === _t.key) _c.value = _t.value;
											})
										}
									})
                                }else{
                                    ele[needUpdate[i]] = memberQualificationList[index][needUpdate[i]]
                                }
                            }
                        }
                    })
                }
            },
            			// 验证
			verify(){
				let errArr = [];
				for(let i=0;i<this.qualificationList.length;i++){
					let item = this.qualificationList[i];
					if(!item.image&&item.is_must!==1)continue;
					if(item.is_must===1&&item.image===''){
						this.$message.error(`请先上传必传资质${item.name}的图片`);
						return false;
					}
					if(item.custom && item.custom.length>0){
						let requiredErrArr = [];
						item.custom.forEach(ele=>{
							if(ele.required==='1'&&ele.value===''){
								requiredErrArr.push(ele.name);
							}
						})
						if(requiredErrArr.length>0){
							this.$message.error(`请填写${item.name}的必填项${requiredErrArr.join(',')}`);
							return false;
						}
					}
					if(item.business_scope_list&&item.business_scope_list.length>0 && item.business_scope_value.length===0){
						errArr.push(item.name);
					}
				}
				if(errArr.length>0){
					this.$message.error(`请填写${errArr.join(',')}的经营范围`)
					return false;
				}
				return true; 
			},
            async onsubmit() {
                if(!this.verify())return;
                // 提交信息
                let qualifications = this.qualificationList.map(ele => {
                    if (!ele.image) return false;
                    return {
                        identify: ele.identify,//资质标识
                        expiration_start_date: ele.expiration_start_date,//开始时间
                        expiration_end_date: ele.expiration_end_date,//结束时间
                        long_term: ele.long_term,//长期有效  1是 0否
                        image: ele.image,
                        card_no: ele.card_no,//证书号
                        custom: ele.custom?ele.custom:null,
                        business_scope:ele.business_scope_value?ele.business_scope_value.map(item=>item).join(","):''
                    }
                }).filter(Boolean)
                const res = await qualificationUpload({ qualifications })
                if (res.code === 0) {
                    this.$message({ message: "提交成功", type: "success" })
                    await this.getMemberQualification()
                } else {
                    this.$confirm(res.message, "提示", {
                        confirmButtonText: "确认"
                    })
                }
                
            },
            handleRemove(file, fileList, item) {
                item.image = ""
                
            },
            handleAvatarSuccess(res, file, item) {
                item.image = res.data.pic_path;
            },
            beforeAvatarUpload(file,name) {
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error(`上传${name}图片大小不能超过 2MB!`)
                }
                return isLt2M
            },
            async getQualificationConfig() {
                const res = await qualificationConfig()
                if (res.code === 0) {
                    this.qualificationList = res.data
                    this.qualificationList.forEach((ele) => {
                        this.$set(ele, "image", "") //图片地址
                        this.$set(ele, "expiration_start_date", "")//开始时间
                        this.$set(ele, "expiration_end_date", "")//结束时间
                        this.$set(ele, "long_term", ele.is_need_long_time)//长期有效  1是 0否
                        this.$set(ele, "card_no", "")//证书号
                        this.$set(ele, "expire_prompt", "")//expire_prompt =1正常, expire_prompt=2 近3个月, expire_prompt=3 已过期
                        this.$set(ele, "status", -2)//审核状态 0待审核 1审核通过  -1审核拒绝
                        this.$set(ele, "business_scope_value",[]);
                        if(ele.custom&&ele.custom.length){
                            this.$set(ele, "custom",ele.custom)
                        }
                    })
                } else {
                    this.$message({
                        message: res.message,
                        type: "warning"
                    })
                }
            },
            inputChange(info){
                if(info.type==='number'&&info.value){
                    const match = info.value.match(/-?\d+(\.\d+)?/);
                    info.value = match ? parseInt(match[0]) : '';
                }
            }
        },
        computed: {
            // 必须传递的资质
            requisiteQualification() {
                return this.qualificationList.filter(ele => ele.is_must === 1)
            },
            // 非必须资质
            nonEssentialQualification() {
                return this.qualificationList.filter(ele => ele.is_must !== 1)
            },
            qualificationGroup() {
                let arr = []
                let requisiteQualification = {
                    _id: 1,
                    type: "必上传资质",
                    qualificationList: this.requisiteQualification
                }
                let nonEssentialQualification = {
                    _id: 2,
                    type: "非必上传资质",
                    qualificationList: this.nonEssentialQualification
                }
                arr.push(requisiteQualification, nonEssentialQualification)
                return arr
            }
        }
    }
</script>
<style lang="scss">
    .el-upload__input{
        display: none !important;
    }
    .downLoadTemplate {
        color: $base-color;
    }
    
    .downLoadTemplate:hover {
        font-family: monospace;
        text-decoration: underline;
        cursor: alias;
    }
    
    .avatar-uploader .el-upload {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 230px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    
    .avatar {
        border: 1px dashed #d9d9d9;
        width: 230px;
        height: 150px;
        display: block;
        
        .qualificationImg {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
        }
    }
</style>
<style lang="scss" scoped>
    .content {
        width: 100%;
    }
    
    .el-card:first-of-type {
        margin-bottom: 10px;
    }
    
    .type-title {
        font-size: 18px;
        font-weight: bold;
        
        .mustIcon {
            color: red;
            margin-right: 6px;
        }
    }
    
    .uploadQualification {
        .qualificationUploadItem {
            .uploadTitle{
                display: flex;
                align-items: center;
                gap: 4px;
                .mustIcon{
                    font-size: 24px;
                    line-height: 24px;
                    color: red;
                    font-weight: bold;
                    position: relative;
                    top: 4px;
                }
                .name{
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
    }
    
    .label-title {
        flex-shrink: 0;
        display: inline-block;
        width: 80px;
    }
    .qualificationInfoBox{
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .customItemClass{
        display: flex;
        align-items: center;
        gap: 12px;
        >span:nth-child(1){
            display: inline-block;
            width: 90px;
            line-height:1;
        }
    }
    .uploadTip{
        display: flex;
        flex-direction: column;
        gap: 6px;
        span{
            color: #32BC6F;
            line-height: 1rem;
        }
    }
    .manageBox{
        display: flex;
        align-items: center;
        gap: 12px;
        .examplePhotos{
            cursor: pointer;
            color: $base-color;
        }
    }
    .examplePhotos{
        max-height: 600px;
        overflow: auto;
    }
</style>
